import React, { useContext, useEffect, useState } from 'react'
import { IoChevronBackOutline, IoClose } from 'react-icons/io5'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'

import { AlertContext } from '../../context/alert_context'
import Loader from '../../components/loader'
import { primary } from '../../utils/colors'
import { useNavigate } from 'react-router-dom'
import { BiTrash } from 'react-icons/bi'
import { MdAdd } from 'react-icons/md'


export default function EditarUsuario({ ...props }, { onClose = () => { } }) {

    const navigate = useNavigate();

    let date = new Date();
    date.setDate(date.getDate() + 1)

    const { user } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    const [state, setState] = useState({
        tab: 0,
        loading: false,
        rol_active: null,
        specialist: null

    })

    const loadSpecialist = async () => {
        setState({ ...state, loading: true })
        console.log(props.userEditing.id)
        let _specialists = await Service('GET', 'User/' + props.userEditing.id);

        state.specialist = _specialists.data;


        setState({ ...state, loading: false })

    }
    useEffect(() => {


        const init = async () => {
            loadSpecialist()
        }
        init()

        return () => { }

    }, [])

    const onUpdateSpecialist = async () => {
        setState({ ...state, loading: true })

        let body = state.specialist;
        console.log(body)



        let add_specialist = await Service('PATCH', `User`, body)
        console.log(add_specialist);
        if (add_specialist.status === 200) {
            notify({ title: 'Listo!', message: 'Se ha actualizado el especialista.', type: 'success' })
            props.onClose()
        } else {
            notify({ title: 'Error!', message: 'No ha sido posible actualizar el especialista.', type: 'error' })
        }
        setState({ ...state, loading: false })
    }


    var arr = [
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
    ]

    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var months = new Array(7);
    months[0] = "January";
    months[1] = "Febrary";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "Octuber";
    months[10] = "November";
    months[11] = "December";

    function onChangeDay(evt, day) {
        if (evt.currentTarget.checked) {
            state.labor_days[day] = true;
            let findDay = state.labor_dates.filter(x => x.dayOfWeek == day);
            if (findDay.length === 0) {
                state.labor_dates.push(
                    {
                        "dayOfWeek": day,
                        "timeRanges": [
                            {
                                "startTime": "08:00:00",
                                "endTime": "17:00:00",
                            }
                        ]
                    }
                );
            }

        } else {
            state.labor_days[day] = false
            state.labor_dates = state.labor_dates.filter(x => x.dayOfWeek !== day);
        }
        setState({ ...state })
    }

    function set_startTime(startTime, day, position) {
        let findDay = state.labor_dates.filter(x => x.dayOfWeek == day);
        findDay[0].timeRanges[position].startTime = startTime;
    }

    function set_endTime(endTime, day, position) {
        let findDay = state.labor_dates.filter(x => x.dayOfWeek == day);
        findDay[0].timeRanges[position].endTime = endTime;
    }
    function onAddSelect(day) {
        let findDay = state.labor_dates.filter(x => x.dayOfWeek == day);
        findDay[0].timeRanges.push(
            {
                "startTime": "08:00:00",
                "endTime": "17:00:00",
            }
        );
        setState({ ...state })
    }

    function onRemoveSelect(day) {
        let findDay = state.labor_dates.filter(x => x.dayOfWeek == day);
        if (findDay[0].timeRanges.length > 1) {
            findDay[0].timeRanges.pop()
        }
        setState({ ...state })
    }

    return (
        <>
            <Renderif isTrue={state.loading === true}>
                <Loader></Loader>
            </Renderif>
            <div className='overlay d-flex justify-content-center align-items-center'>


                <div className='bv-modal overflow-auto hide-scroll shadow'>

                    <div className='d-flex  p-3'>

                        <div className='col'></div>
                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                            props.onClose()
                        }}>
                            <IoClose size={30} color={primary}></IoClose>
                        </div>


                    </div>
                    <Renderif isTrue={state.tab === 0}>
                        <div className='d-flex px-3'>

                            <div className='col px-3'>

                                <div className='mt-3'>
                                    <div className='f-14 bold text-gray'>Nombre</div>
                                    <div className='input--light'>
                                        <input value={state.specialist?.firstName} onChange={(evt) => {
                                            state.specialist.firstName = evt.currentTarget.value
                                            setState({ ...state })
                                        }} placeholder='Nombre Apellido'></input>
                                    </div>
                                </div>

                                <div className='mt-3'>
                                    <div className='f-14 bold text-gray'>Apelidos</div>
                                    <div className='input--light'>
                                        <input value={state.specialist?.lastName} onChange={(evt) => {
                                            state.specialist.lastName = evt.currentTarget.value
                                            setState({ ...state })
                                        }} placeholder='Apellido'></input>
                                    </div>
                                </div>

                                <div className='mt-3'>
                                    <div className='f-14 bold text-gray'>Correo electrónico</div>
                                    <div className='input--light'>
                                        <input value={state.specialist?.email} onChange={(evt) => {
                                            state.specialist.email = evt.currentTarget.value
                                            setState({ ...state })
                                        }} placeholder='correo@dominio.com'></input>
                                    </div>
                                </div>

                                <div className='mt-3'>
                                    <div className='f-14 bold text-gray'>Teléfono</div>
                                    <div className='input--light'>
                                        <input type='number' value={state.specialist?.cellPhone} onChange={(evt) => {
                                            state.specialist.cellPhone = evt.currentTarget.value
                                            setState({ ...state })
                                        }} placeholder='11 22 33 44 55'></input>
                                    </div>
                                </div>

                            </div>




                        </div>

                    </Renderif>
                    <div className='d-flex b-top p-4'>

                        <div className='col'></div>

                        <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                            props.onClose()
                        }}>Cancelar</div>

                        <div className='bv-pill bv-pill--green cursor-pointer px-4' onClick={() => {
                            onUpdateSpecialist()
                        }}>Guardar</div>
                    </div>

                    <div className=''></div>







                </div>


            </div>
        </>
    )
}
